import Lenis from '@studio-freight/lenis';
window.lenis = new Lenis({
    autoResize: true,
    normalizeWheel: true,
    duration: 1
});
function raf(time) {
    window.lenis.raf(time);
    requestAnimationFrame(raf);
}
requestAnimationFrame(raf);
